import { useLang } from "@/context/LangContext";

// WhatsApp icon (inline SVG — lucide doesn't ship a branded one)
function WhatsAppIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M20.52 3.48A11.93 11.93 0 0 0 12.04 0C5.46 0 .1 5.36.1 11.94c0 2.1.55 4.15 1.6 5.95L0 24l6.27-1.64a11.9 11.9 0 0 0 5.77 1.47h.01c6.58 0 11.94-5.36 11.94-11.94 0-3.19-1.24-6.19-3.47-8.41ZM12.05 21.8h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.22-3.72.97.99-3.63-.23-.37a9.86 9.86 0 0 1-1.51-5.23c0-5.46 4.45-9.9 9.92-9.9 2.65 0 5.14 1.03 7.01 2.9a9.85 9.85 0 0 1 2.9 7.02c0 5.46-4.45 9.84-9.96 9.84Zm5.44-7.38c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.88-.79-1.48-1.77-1.66-2.06-.17-.3-.02-.46.13-.6.14-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.21-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.08.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.2 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.34Z" />
    </svg>
  );
}

export default function ShareBar() {
  const { lang } = useLang();

  const shareUrl =
    typeof window !== "undefined"
      ? (window.location.href || window.location.origin)
      : "";
  const text =
    lang === "ta"
      ? "நீயோசி — உங்கள் வேட்பாளரை அறியுங்கள். நீங்கள் யாருக்கு வாக்களிக்கிறீர்கள் என்று தெரியுமா? அவருக்குக் குற்றப் பதிவு உள்ளதா? அவர் படித்தவரா?"
      : "NeeYosi — Know Your Candidate. Do you know who you're voting for? Does he have a criminal record? Is he educated?";

  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(text + " " + shareUrl)}`;

  function openPopup(url) {
    window.open(url, "_blank", "noopener,width=620,height=640");
  }

  const btn =
    "inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/10 hover:bg-white/22 text-white transition border border-white/15 hover:border-white/30";

  return (
    <div
      className="relative flex flex-col items-end gap-1"
      data-testid="share-bar"
      aria-label="Share this site"
    >
      <div className="inline-flex items-center gap-1.5">
        <button
          onClick={() => openPopup(whatsappUrl)}
          className={btn}
          aria-label="Share on WhatsApp"
          title="Share on WhatsApp"
          data-testid="share-whatsapp-btn"
        >
          <WhatsAppIcon size={15} />
        </button>

      </div>

    </div>
  );
}
